import { Request, ParamsDictionary, Response } from "express-serve-static-core";
import { ParsedQs } from "qs";

export abstract class RenderableError<ResBody = unknown> extends Error {
  abstract render(
    req: Request<ParamsDictionary, ResBody, unknown, ParsedQs, Record<string, unknown>>,
    res: Response<ResBody, Record<string, unknown>>,
  ): void;
}
